import type { ComponentType } from "react"
import {
  CalendarOutlined,
  NotificationOutlined,
  UserOutlined,
  TeamOutlined,
  FileTextOutlined,
  DollarOutlined,
  MailOutlined,
  InboxOutlined,
} from "@ant-design/icons"
import { Resource } from "@mimber/schema"

export interface ResourceDisplayConfig {
  label: string
  icon: ComponentType | null
}

/**
 * Label + icon for each Resource value that is meaningful to surface in a
 * picker. Resources without a UI-facing meaning (e.g. ALL, ADMINISTRATOR)
 * are intentionally omitted — callers restrict the offered options via the
 * `resources` prop, so only entries that are actually passed in are used.
 */
export const RESOURCE_DISPLAY_CONFIG: Partial<
  Record<Resource, ResourceDisplayConfig>
> = {
  [Resource.EVENT]: { label: "Events", icon: CalendarOutlined },
  [Resource.ANNOUNCEMENT]: {
    label: "Announcements",
    icon: NotificationOutlined,
  },
  [Resource.MEMBERSHIP]: { label: "Memberships", icon: UserOutlined },
  [Resource.GROUP]: { label: "Groups", icon: TeamOutlined },
  [Resource.INVOICE]: { label: "Invoices", icon: FileTextOutlined },
  [Resource.DONATION]: { label: "Donations", icon: DollarOutlined },
  [Resource.COMMUNICATION_TEMPLATES]: {
    label: "Templates",
    icon: MailOutlined,
  },
  [Resource.WAITLIST]: { label: "Waitlist", icon: InboxOutlined },
}

export const getResourceDisplayConfig = (
  resource: Resource
): ResourceDisplayConfig =>
  RESOURCE_DISPLAY_CONFIG[resource] ?? { label: resource, icon: null }
